import * as React from 'react';

// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled (now we have them hardcoded in our jsx).
//       Had trouble extending our CardContentCProps...
export const CollectionContentB = (props: any) => {
  const { description, title, limit, className, ...other } = props;
  return <></>;
};
